import { ImportStopsDataStage } from '.';
import { DataImporterStepperHeader } from '../../components/data-importer/DataImporterStepperHeader';

interface StepperHeaderProps {
  stage: ImportStopsDataStage;
  shouldUsePickups: boolean;
  shouldUseTasks: boolean;
}

export const StepperHeader = ({ stage, shouldUsePickups, shouldUseTasks }: StepperHeaderProps) => {
  const availableStages: ImportStopsDataStage[] = [`map_stop_fields`];
  if (shouldUseTasks) {
    availableStages.push(`map_task_fields`);
  }
  if (shouldUsePickups) {
    availableStages.push(`map_pickup_fields`);
  }
  availableStages.push(`review_addresses`);

  return <DataImporterStepperHeader stage={stage} availableStages={availableStages} />;
};
